<pms-container
  [able]="able()"
  [load]="load()"
  [loadParams]="loadParams()"
  [noData]="noData()"
  [loaderCssClass]="loaderCssClass()"
  [loaderType]="loaderType()"
  [brokerEvents]="brokerEvents()"
  [template]="computedTemplateRef()"
  [tab]="effectiveTab()"
  (data)="data.emit($event)"
></pms-container>
